import React from "react";

const MentionsLegales = () => {
  return (
    <>
    <div className="bg-dark text-white text-center py-3">
      <h1>Mentions Llégales</h1>
      <p>A définir</p>
      </div>
    </>
  );
};

export default MentionsLegales;
